export default "__VITE_ASSET__pbbYjmVB__"